"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatstr = void 0;
const flatstr = (s) => {
    s | 0;
    Number(s);
    return s;
};
exports.flatstr = flatstr;
